import type { ResourceConfig } from "../types";

export const dashboardConfig = {
  displayName: "仪表盘",
  category: "dashboard",
  permissions: {
    "read:admin": {
      label: "访问管理员仪表盘",
      description: "可以查看管理员仪表盘（教练绩效等）",
    },
    "read:coach": {
      label: "访问教练仪表盘",
      description: "可以查看教练个人仪表盘",
    },
    "read:own": {
      label: "查看自己的绩效数据",
      description: "可以查看与自己相关的绩效详情数据",
    },
  },
  navigation: {
    path: "/dashboard/staff-performance",
    label: "教练绩效",
    icon: "BarChart3" as const,
    requiredPermissions: ["read:admin"] as const,
    group: "management" as const,
    order: 10,
  },
} satisfies ResourceConfig;
